import QCXList from '../list/QCXList';

export default function QCXListMenu({ children, ...restProps }) {
  return (
    <QCXList {...restProps}>
      {children}
    </QCXList>
  );
}
